package com.xtream.composeapp.viewmodel





import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.db.repo.UserRepo
import com.xtream.data_kmp.db.utils.XorEncDec
import com.xtream.data_kmp.dto.Account
import com.xtream.data_kmp.dto.BaseAccount
import com.xtream.data_kmp.dto.XtreamActivationBaseUserInfo
import com.xtream.data_kmp.remote.createApiService
import com.xtream.data_kmp.remote.repo.DeviceInfo
import com.xtream.data_kmp.util.exception.UserNotFoundException
import com.xtream.data_kmp.util.exception.getErrorMessage
import io.ktor.client.call.body
import io.ktor.http.isSuccess
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

@Serializable
data class ActivationRequest(
    val mode: String,
    val code: String,
    val mac: String,
    val sn: String,
    val chipid: String = "",
    val model: String,
    @SerialName("firmware_ver")
    val firmwareVersion: String
)
class UserViewModel (
    private val userRepo: UserRepo,
    private  val appSettingsRepo: PreferencesRepo
):ViewModel() {

    val userInfoState = MutableStateFlow<ApiSealed<BaseAccount>>(ApiSealed.Initial)

    suspend fun userServerUrlViewModel() = userRepo.getUserServerUrl()
    val loggedInUserFlow=userRepo.getLoggedInUserFlow()
    suspend fun loggedInUser() =userRepo.getLastLoggedInUser()




    private val coroutineExceptionHandler = CoroutineExceptionHandler{ _, throwable ->
        throwable.printStackTrace()
    }
    fun loadUser(username:String?, password:String?,
                 serverUrl:String?=null,
                 onSuccess: (suspend  () -> Unit?)? =null,
                 onError: ((String) -> Unit)?=null,
                 needInsertUser:Boolean=true) {

        if (username.isNullOrEmpty() || password.isNullOrEmpty()) {
            userInfoState.value = ApiSealed.Error("Error: username or password is empty")
            return
        }
        viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            userInfoState.value = ApiSealed.Loading

            try {
                val baseUrl = serverUrl?:appSettingsRepo.getPref(PreferencesRepo.ACCOUNT_SERVER_URL_KEY)

                val client = createApiService("${baseUrl}${SharedBuildKonfig.SERVER_API}", username, password) /*HttpClient(OS.Android) {
                    if (Build.VERSION.SDK_INT <= Build.VERSION_CODES.N) {
                        engine {
                            sslManager = { httpsURLConnection ->
                                httpsURLConnection.sslSocketFactory =
                                    KtorSslHelper.getUnsafeSSLSocketFactory()
                                httpsURLConnection.hostnameVerifier =
                                    HostnameVerifier { _, _ -> true }
                            }
                        }
                    }
                    install(Logging) {
                        level = LogLevel.ALL
                    }
                    install(ContentNegotiation) {

                        json(Json {
                            ignoreUnknownKeys = true
                            isLenient = true
                            encodeDefaults = false
                            explicitNulls = true
                        })
                    }
                }*/

                //Clock.System.now().toEpochMilliseconds()
                //  val apiService = ApiService.create()
                // val liveStreams = apiService.getVodStreams().body<String>()
                val response = client.login()

                if (response.status.isSuccess()) {
                   // Log.d(javaClass.simpleName, response.body())
                    val body = response.body<Account>()
                    if (body.userInfo.auth != 1) {
                        if (body.userInfo.auth == 0) {
                            throw UserNotFoundException()

                        } else userInfoState.value =
                            ApiSealed.Error("Error code ${response.status}")

                    } else {
                      //  Log.d("#Request:", "userinfo:$body")
                        when (body.userInfo.status?.lowercase()) {
                            "expired" -> {
                                userInfoState.value =
                                    ApiSealed.Error(AllConst.ACCOUNT_EXPIRED_EXCEPTION)

                            }

                            "active" -> {

                                userInfoState.value = ApiSealed.Success(body)
                                if (needInsertUser)
                                    userRepo.login(body)

                                onSuccess?.invoke()
                            }

                            else -> {
                                userInfoState.value =
                                    ApiSealed.Error(AllConst.ACCOUNT_UNAVAILABLE_EXCEPTION)

                            }
                        }
                    }
                } else {

                    if (response.status.value == 404)
                        userInfoState.value = ApiSealed.Error(
                            AllConst.ACCOUNT_UNAVAILABLE_EXCEPTION,
                            serverMessage = loggedInUser()?.userInfo?.activationCode
                                ?: loggedInUser()?.userInfo?.username
                        )
                    else {
                        userInfoState.value = ApiSealed.Error("Error code: ${response.status}")
                    }

                }



            } catch (e: Exception) {
               // Log.d("checkByActivationCode: ", "Error:${e}")

                val msg = e.getErrorMessage()
                userInfoState.value = ApiSealed.Error(msg)
                onError?.invoke(msg)

            }
        }

    }

@ExperimentalSerializationApi
fun refreshAccount() {
    val account = userInfoState.value

    with(account as? ApiSealed.Success<BaseAccount>?) {
        this?.data?.userInfo?.let {

            loadUser(it.username, it.password)
        }
    }
}


   // @SuppressLint("HardwareIds")
    fun checkByActivationCode(activationCodeVal:String?,
                              deviceInfo: DeviceInfo,

                              onSuccess: (suspend () -> Unit)?=null, onError: ((String) -> Unit)?=null) {
        userInfoState.value=ApiSealed.Loading
        //Log.d( "checkByActivationCode: ", "activationCodeVal:$activationCodeVal")
        if (activationCodeVal.isNullOrEmpty()) {
            userInfoState.value = ApiSealed.Error("Error: code is empty")
            return
        }
//Payload =
// {"mode":"active",
// "code":"282110848136",
// "mac":"00:11:5c:9a:e4",
// "sn":"00:11:5c:9a:e4",
// "chipid":"000000",
// "model":"get by: android.os.Build.MODEL",
// "firmware_ver":"get by: Build.VERSION.RELEASE"}
        /*data.put("mode", "active")
        data.put("code", activationCodeVal)
        data.put("mac", deviceId.getMacFormatedString())
        data.put("sn", deviceId)
        data.put("chipid", "")
        data.put("model", Build.MODEL)
        data.put("firmware_ver", Build.VERSION.RELEASE)*/



        viewModelScope.launch(Dispatchers.Default) {


            try {


       val data  = Json.encodeToString(
                    ActivationRequest(
                        mode = "active",
                        code = activationCodeVal,
                        mac = deviceInfo.macAddress,
                        sn = deviceInfo.deviceId,
                        model = deviceInfo.model,
                        firmwareVersion = deviceInfo.firmwareVersion
                    )
                )// JSONObject("""{"mode":"active","code":"$activationCodeVal","mac":"${deviceInfo.macAddress}","sn":"${deviceInfo.deviceId}","chipid":"","model":"${deviceInfo.model}","firmware_ver":"${deviceInfo.firmwareVersion}"}""")

               /*HttpClient(OS.Android) {
                    if (Build.VERSION.SDK_INT <= Build.VERSION_CODES.N) {
                        engine {
                            sslManager = { httpsURLConnection ->
                                httpsURLConnection.sslSocketFactory =
                                    KtorSslHelper.getUnsafeSSLSocketFactory()
                                httpsURLConnection.hostnameVerifier =
                                    HostnameVerifier { _, _ -> true }
                            }
                        }
                    }

                    install(Logging) {
                        if(BuildConfig.DEBUG) {
                            logger = object : Logger {
                                override fun log(message: String) {
                                    Log.d("KtorLog", message)
                                }
                            }
                            level = LogLevel.ALL // FULL detail: headers + bodies + method + URL}
                        }
                    }
                    install(ContentNegotiation) {

                        json(Json {
                            ignoreUnknownKeys = true
                            isLenient = true
                            encodeDefaults = false
                            explicitNulls = false

                        })
                    }
                }*/

                val baseUrl= appSettingsRepo.getPref( PreferencesRepo.ACTIVATION_SERVER_URL_KEY)
                val key= appSettingsRepo.getPref( PreferencesRepo.ACTIVATION_XOR_KEY)
                val client = createApiService(baseUrl?:"")
                val encryptedData = XorEncDec.encDec(msg=data.toString(), key=key?:"" )

                val response = client.activate(encryptedData)/*client.submitForm (
                    url=baseUrl?:"",
                    formParameters = parameters {
                        append("json", encryptedData)
                    }
                )*/

                if (response.status.isSuccess()) {
                    val decryptedResponse = XorEncDec.encDec(response.body(),key=key?:"")
                    val body = Json.decodeFromString<XtreamActivationBaseUserInfo>(decryptedResponse)
                    // Log.d("checkByActivationCode", decryptedResponse.toString())

                    body.userInfo?.activationCode = activationCodeVal
                   // Log.d( "checkByActivationCode: ", "activationCodeVal:${body.userInfo}")

                    if (body.userInfo?.status in listOf("100", "101")) {
                        body.toXtreamUser()?.also {
                            userInfoState.value = ApiSealed.Success(body)

                            appSettingsRepo.apply {

                            }
                            userRepo.login(it)


                        }
                        onSuccess?.invoke()
                    }
                    else if (body.userInfo?.status.equals("4")) {
                        userInfoState.value = ApiSealed.Error(AllConst.ACCOUNT_EXPIRED_EXCEPTION, serverMessage = body.userInfo?.let { "\nCode: $activationCodeVal\n\nStatus: ${it.message} (Error Code: ${it.status})\n" })
                        onError?.invoke(AllConst.ACCOUNT_EXPIRED_EXCEPTION)
                    }
                    else if (listOf("7").contains(body.userInfo?.status)) {

                        userInfoState.value = ApiSealed.Error(AllConst.ACCOUNT_UNAVAILABLE_EXCEPTION, serverMessage = body.userInfo?.let { "\nCode: $activationCodeVal\n\nStatus: ${it.message} (Error Code: ${it.status})\n" })
                        onError?.invoke(AllConst.ACCOUNT_UNAVAILABLE_EXCEPTION)
                    }
                    else {
                        userInfoState.value = ApiSealed.Error("Code Unavailable, Error code: ${body.userInfo?.status}")
                        onError?.invoke(AllConst.ACCOUNT_UNAVAILABLE_EXCEPTION.plus( " (Code: ${body.userInfo?.status})"))

                    }

                    //}
                } else {
                    userInfoState.value = ApiSealed.Error("Error code ${response.status}")
                    onError?.invoke("Error code ${response.status}")


                }


            } catch (e: Exception) {
               // Log.d( "checkByActivationCode: ", "Error:${e}")

                val msg = e.getErrorMessage()
                userInfoState.value = ApiSealed.Error(msg)
                onError?.invoke(msg)

            }


        }

    }

   @OptIn(ExperimentalSerializationApi::class)
   suspend fun reLoadUser() {
     val lastLoggedInUser =  userRepo.getLastLoggedInUser()

           lastLoggedInUser?.userInfo?.apply {
         // if (activationCode != null)
         //     checkByActivationCode(activationCode, context)
         // else {

               loadUser(username, password, onSuccess = {

               })
         //  }
       }
    }

suspend fun logOut(){
    userRepo.logout()
    appSettingsRepo.clearPref(PreferencesRepo.LAST_DATA_UPDATE_MILlIS_KEY)
    userInfoState.value = ApiSealed.Initial
}
    suspend fun resetLastDataUpdateTime(onDone: (() -> Unit)? = null) {
        appSettingsRepo.clearPref(PreferencesRepo.LAST_DATA_UPDATE_MILlIS_KEY)
        onDone?.invoke()
    }

}

